import { Property, Schema } from 'hooks/projects';
import { PRIMARY_KEY_FDM } from './config';

const getSchemaByName = (
  schemas: Schema[],
  schemaName: string | null | undefined
) => schemas.find((sch) => sch?.name === schemaName?.replace(/\[|\]|!/gi, '')); // Removes all [, ] and ! to get a clean propetry name.

export const getSchemaNameForProperty = (
  property: Property,
  schemas: Schema[]
) => getSchemaByName(schemas as Schema[], property.type);

const isInternalCompositeType = (type: string | null | undefined) =>
  ['Date', 'DateTime', 'LocalDateTime', 'Point'].find(
    (ct) => ct === type?.replace(/\[|\]|!/gi, '')
  );

// Get data without complex types for given schema properties and ids
export const convertToSimpleQueryFDM = (
  schemaName: string,
  propertiesToFetch: Property[],
  projectSchemas: Array<Schema | null>,
  failedInstancesIds?: Object[]
): string => `
    list${schemaName} (
      filter: { 
        ${PRIMARY_KEY_FDM}: {in: [${failedInstancesIds}]}
      }) 
      {
        items {
          ${PRIMARY_KEY_FDM}
          ${propertiesToFetch
            .map(({ type, name }: Property) => {
              const childSchema = projectSchemas.find(
                (sch) =>
                  type === sch?.name ||
                  type === `${sch?.name}!` ||
                  type === `[${sch?.name}]` ||
                  type === `[${sch?.name}!]` ||
                  type === `[${sch?.name}!]!`
              );
              return childSchema || isInternalCompositeType(type)
                ? `${name} {
                items {
                  ${PRIMARY_KEY_FDM}
                }
              }`
                : name;
            })
            .join('\n')}
          }
        }
    `;

const compareAttributeNames = (attribute1: Property, attribute2: Property) => {
  if (!attribute1 || !attribute1?.name) return 0;
  if (!attribute2 || !attribute2?.name) return 0;
  if (attribute1?.name.toLowerCase() > attribute2?.name.toLowerCase()) {
    return 1;
  }
  if (attribute1?.name.toLowerCase() < attribute2?.name.toLowerCase()) {
    return -1;
  }
  return 0;
};

export const sortAttributesAlphabetically = (attributes: Property[]) =>
  attributes.slice().sort(compareAttributeNames);
